export enum EnvCodeEnum {
  PROD = 1,
  PROD_TEXT = "production",
  STAGING = 2,
  STAGING_TEXT = "staging",
  TEST = 3,
  TEST_TEXT = "test",
  LOCAL = 4,
  LOCAL_TEXT = "local",
  SANDBOX = 5,
  SANDBOX_TEXT = "sandbox",
}

export enum LanguagesEnum {
  LT = "lt",
  PL = "pl",
}
